import * as api from 'common/api'
import * as Department from './department'
import * as Teacher from './teacher'

export let status = () => ([
  {name: '禁用', id: '禁用'},
  {name: '启用', id: '启用'},
])

// 管理端收集任务列表
export let list = () => api.get('s3/collection/list')

// 管理端查看一个收集任务
export let get = params => api.get('s3/collection/edit', params)

// 管理端创建、编辑一个收集任务
export let edit = params => api.postFile('s3/collection/edit', params)

// 管理端启用、禁用一个收集任务
export let toggle_disable = params => api.postFile('s3/collection/edit', {
  uid: params.uid,
  status: params.status === '禁用' ? '启用' : '禁用',
})

// 管理端删除一个收集任务
export let remove = params => api.post('s3/collection/delete', params)

// 教师端收集任务列表
export let teacher_list = () => api.get('s3/collection/teacher/list')

// 教师端查看一个任务
export let teacher_get = params => api.get('s3/collection/teacher/edit', params)

// 教师端编辑任务、上传文件
export let teacher_edit = params => api.postFile('s3/collection/teacher/edit', params)

// 删除教师的上传
export let teacher_remove = params => api.post('s3/collection/teacher/delete', params)

// 管理员可以发出任务的部门
export let user_department_list = async params => {
  let [departments, user] = await Promise.all([
    Department.list(),
    Teacher.get(params),
  ])
  return departments.filter(department => {
    return user.departments.includes(department.uid) && department.funcs.includes('admin_plan')
  })
}

export let batch_download = params => api.get('s3/collection/download', params)



// WEBPACK FOOTER //
// ./src/api/collection.js